var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8003 1.99988H8.80029C6.59115 1.99988 4.80029 3.79074 4.80029 5.99988V17.9999C4.80029 20.209 6.59115 21.9999 8.80029 21.9999H18.8003C19.9049 21.9999 20.8003 21.1044 20.8003 19.9999V3.99988C20.8003 2.89531 19.9049 1.99988 18.8003 1.99988ZM6.80028 5.99975C6.80028 4.89518 7.69572 3.99975 8.80029 3.99975H18.8003V13.9998H8.80029C8.09532 14.0027 7.40428 14.1962 6.80028 14.5598V5.99975ZM8.80029 19.9998C7.69572 19.9998 6.80028 19.1043 6.80028 17.9998C6.80028 16.8952 7.69572 15.9998 8.80029 15.9998H18.8003V19.9998H8.80029ZM10.8003 8H14.8003C15.3526 8 15.8003 7.55228 15.8003 7C15.8003 6.44772 15.3526 6 14.8003 6H10.8003C10.248 6 9.80029 6.44772 9.80029 7C9.80029 7.55228 10.248 8 10.8003 8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookAlt);
export default __webpack_public_path__ + "static/media/book-alt.6de6fdaf.svg";
export { ForwardRef as ReactComponent };